import { Input } from "antd";
import { useState } from "react";

interface SearchFilterProps {
  placeholder: string;
  data: any[];
  setData: React.Dispatch<React.SetStateAction<any>>;
  field: string;
}

export const SearchFilter = ({
  placeholder,
  data,
  setData,
  field,
}: SearchFilterProps) => {
  const [value, setValue] = useState("");

  return (
    <div>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          const currValue = e.target.value;
          setValue(currValue);
          if (!currValue) {
            setData(data);
            return;
          }

          const filteredData = data.filter((entry) =>
            entry[field].toLocaleLowerCase().includes(currValue.toLowerCase())
          );
          setData(filteredData);
        }}
      />
    </div>
  );
};
